import service from "../services/AuthenticationService";

class AuthenticationApi {
    impersonateUser (userId, productName) {
        const request = {
            UserId: userId,
            Product: productName
        };
        return new Promise((resolve, reject) => {
            service.impersonate(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    accessSite (userId, product, returnUrl) {
        const request = {
            UserId: userId,
            Product: product,
            ReturnUrl: returnUrl
        };

        return new Promise((resolve, reject) => {
            service.virtualUserImpersonate(request)
                .then(res => resolve(res.data.Url))
                .catch((err) => reject(err));
        });
    }

    loginToSisense (orgId, virtualUserId) {
        return new Promise((resolve, reject) => {
            service.loginToSisense(orgId, virtualUserId)
                .then(res => resolve(res.data.Url))
                .catch((err) => reject(err));
        });
    }
}

export default new AuthenticationApi();
